/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_From_EndInputs */

const en_templates_from_end = /** @type {(inputs: Templates_From_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offset measured from the lesson's end`)
};

const he_templates_from_end = /** @type {(inputs: Templates_From_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ההיסט נמדד מסיום השיעור`)
};

/**
* | output |
* | --- |
* | "Offset measured from the lesson's end" |
*
* @param {Templates_From_EndInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const templates_from_end = /** @type {((inputs?: Templates_From_EndInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_From_EndInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_from_end(inputs)
	return he_templates_from_end(inputs)
});